const SpinnerPage = () => {
  return (
    <>
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </>
  );
};

export default SpinnerPage;
